import React, {useEffect,useState}from 'react';
import { Container, Nav, Navbar, Dropdown} from 'react-bootstrap';
import { FaUserCircle } from 'react-icons/fa';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import UTCTime from '../../Components/UTCTime/UTCTime';
import './AppNavbar.scss'
import "@maersk-global/mds-react-wrapper/styles/core.css";
import { useMsal } from '@azure/msal-react';

const AppNavbar: React.FC = () => {
  const [show, setShow] = useState(false);
  const[activeUserName,setActiveUserName]= useState<string>('');
  const[isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const { instance } = useMsal();

  useEffect(()=> {
    const activeAccount=instance.getActiveAccount();
    setActiveUserName(activeAccount?.name || '');
  },[instance]);

  useEffect(()=>{
    const sidebar = document.querySelector('[data-sidebar-state]');
    const observer = new MutationObserver(()=>{
      setIsSidebarExpanded(sidebar?.getAttribute('data-sidebar-state')==='expanded');
    });
    if (sidebar) observer.observe(sidebar, {attributes: true});
    return () => observer.disconnect();
  },[]);

  const toggleDropdown = () => setShow(!show);

  const handleLogout = () => {
    instance.logoutRedirect(); 
  };
  return (
    <Navbar className={`navbar-top ${isSidebarExpanded ? 'with-sidebar':''}`}>
      <Container fluid>
        <Navbar.Brand className={`navbar-left mds ${isSidebarExpanded ? 'shift-right' : ''}`}>Sherlock</Navbar.Brand>
        <Nav className='mx-auto'>
          <Nav.Item className='navbar-center mds'>
            <UTCTime />
          </Nav.Item>
        </Nav>
        <Nav className='navbar-right'>
        <Dropdown align="end" show={show} onToggle={(isOpen)=> setShow(isOpen)}>
        <Dropdown.Toggle as="span" onClick={toggleDropdown} style={{ cursor: 'pointer', fontWeight: 'light' }} role="button" aria-label={activeUserName || "No active user"}>
              {activeUserName}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {/* <Dropdown.Item href="#profile" className='Dropdown'>Profile</Dropdown.Item> */}
              <Dropdown.Item onClick={handleLogout} className='Dropdown'>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* <Nav.Link href='#help'>
            <AiOutlineInfoCircle size={30} />
          </Nav.Link> */}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
